// base64peek.js — click a base64 string in an OP/reply to decode it in place.
// Thread pages only (loaded from thread.njk). No inline handlers (CSP).

var base64peek = {};

// Candidate extraction: same filter set as the operator-provided reference,
// relaxed to also accept unpadded base64 (len % 4 === 2) — common when pasted
// from terminals. Hex-only and alpha-only strings are dropped (hashes/words).
// Boundaries exclude . - _ as well: a candidate adjacent to those is almost
// certainly part of a URL/domain/path, not a pasted base64 blob.
var B64_RE = /(?:^|[^A-Za-z0-9+/=.\-_])([A-Za-z0-9+/]{16,}={0,2})(?=$|[^A-Za-z0-9+/=.\-_])/g;

// The ONLY thing this feature is for: base64-obfuscated URLs users paste to hide a
// file-hosting link from search engines (e.g. https://gofile.io/d/XXXX). So the hard
// gate is on the DECODED value — it must be an https:// link. That single check kills
// the whole word/slug false-positive class ("gaslit/manipulated", "foo/bar/baz", pasted
// tokens) that atob alone would happily accept, with no brittle entropy/length heuristic.
function isB64Candidate(s) {
  var m = s.length % 4;
  if (m !== 0 && m !== 2) return false;
  if (/^[0-9A-Fa-f]+$/.test(s)) return false; // hex hashes (MD5/SHA/UUID-ish)
  if (/^[A-Za-z]+$/.test(s)) return false;   // long concatenated words
  var decoded = decodeB64(s);
  return !!decoded && /^https:\/\//.test(decoded);
}

// Decode to UTF-8; returns null if the bytes are not plausible text.
function decodeB64(s) {
  var bin;
  try { bin = atob(s); } catch (e) { return null; }
  var bytes = new Uint8Array(bin.length);
  for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  var text;
  try { text = new TextDecoder('utf-8', { fatal: true }).decode(bytes); }
  catch (e) { return null; } // invalid UTF-8 -> binary payload
  if (/[^\x20-\x7E\t\n\r]/.test(text)) return null; // control chars / non-Latin1-ish
  return text;
}

// Clipboard with http fallback (navigator.clipboard needs a secure context;
// this site is plain HTTP on the LAN, so execCommand does the real work).
function copyText(t) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(t);
  }
  var ta = document.createElement('textarea');
  ta.value = t;
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  var ok = false;
  try { ok = document.execCommand('copy'); } catch (e) {}
  document.body.removeChild(ta);
  return Promise.resolve(ok);
}

function enhanceTextNode(node) {
  var text = node.data;
  B64_RE.lastIndex = 0;
  var match, hits = [];
  while ((match = B64_RE.exec(text)) !== null) {
    if (isB64Candidate(match[1])) {
      hits.push({ start: match.index + (match[0].length - match[1].length), end: match.index + match[0].length, value: match[1] });
    }
  }
  if (!hits.length) return;

  var frag = document.createDocumentFragment();
  var cursor = 0;
  for (var i = 0; i < hits.length; i++) {
    var h = hits[i];
    if (h.start > cursor) frag.appendChild(document.createTextNode(text.slice(cursor, h.start)));
    var span = document.createElement('span');
    span.className = 'b64peek';
    span.textContent = h.value;
    span.title = 'base64 — click to decode';
    (function (value) {
      span.addEventListener('click', function () { base64peek.decode(span, value); });
    })(h.value);
    frag.appendChild(span);
    cursor = h.end;
  }
  if (cursor < text.length) frag.appendChild(document.createTextNode(text.slice(cursor)));
  node.parentNode.replaceChild(frag, node);
}

function enhanceRoot(root) {
  var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode: function (n) {
      if (!n.data || !n.data.trim()) return NodeFilter.FILTER_REJECT;
      var p = n.parentNode;
      while (p && p !== root) {
        var tag = p.nodeName;
        if (tag === 'A' || tag === 'CODE' || tag === 'PRE' || tag === 'SCRIPT' || tag === 'STYLE') {
          return NodeFilter.FILTER_REJECT;
        }
        // Idempotency: never re-enter our own already-wrapped spans
        if (p.classList && p.classList.contains('b64peek')) return NodeFilter.FILTER_REJECT;
        p = p.parentNode;
      }
      return NodeFilter.FILTER_ACCEPT;
    }
  });
  var nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  for (var i = 0; i < nodes.length; i++) enhanceTextNode(nodes[i]);
}

base64peek.decode = function (span, value) {
  if (span.classList.contains('decoded')) return; // already revealed
  var decoded = decodeB64(value);
  if (!decoded || !/^https:\/\//.test(decoded)) {
    span.classList.add('binary');
    span.title = 'not a link';
    return;
  }
  span.textContent = decoded;
  span.classList.add('decoded');
  span.title = 'decoded from base64 — click to copy';
  span.onclick = function () {
    copyText(decoded).then(function (ok) {
      if (ok) {
        var t = span.title;
        span.title = 'copied';
        setTimeout(function () { span.title = t; }, 1200);
      }
    });
  };
};

base64peek.init = function () {
  var cells = document.querySelectorAll('.opCell, .postCell');
  for (var i = 0; i < cells.length; i++) enhanceRoot(cells[i]);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', base64peek.init);
} else {
  base64peek.init();
}
